import StackIcon from "tech-stack-icons";

export const certificationsData = [
    {
        title: "AWS Data Engineer – Associate",
        issuer: "Amazon Web Services",
        date: "Cloud",
        description: "Cloud data architecture and ETL optimization."
    },
    {
        title: "AWS Machine Learning – Specialty",
        issuer: "Amazon Web Services",
        date: "Cloud",
        description: "Machine learning modeling and SageMaker deployment."
    },
    {
        title: "AWS Developer – Associate",
        issuer: "Amazon Web Services",
        date: "Cloud",
        description: "Cloud-native application development."
    },
    {
        title: "PCAP 31-03",
        issuer: "Python",
        date: "Develop",
        description: "Professional Python Developer Associate programming standards."
    },
];

const Certifications = () => (
    <section className="max-w-[900px] mx-auto py-8 px-4">
        <h2 className="font-bold text-2xl text-slate-800 mb-6 text-center font-inter tracking-tight">
            🎓 Certificazioni
        </h2>
        <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 justify-center gap-4">
            {certificationsData.map((cert) => (
                <div
                    key={cert.title}
                    className="bg-gradient-to-br w-full h-full from-slate-50 to-indigo-100 rounded-xl shadow-md p-5 border border-indigo-100 flex-1 transition-transform"
                >
                    <div className="mb-2">
                        <div>
                            {cert.issuer === "Amazon Web Services" && (
                                <StackIcon name="aws" className="w-10" />
                            )}
                            {cert.issuer === "Python" && (
                                <StackIcon name="python" className="w-10" />
                            )}
                        </div>
                        <div className="text-indigo-600 font-bold text-base mt-1">
                            {cert.title}
                        </div>
                    </div>
                    <div className="text-slate-500 font-medium text-sm">{cert.issuer}</div>
                    <div className="text-indigo-300 text-xs italic mb-2">{cert.date}</div>
                    <div className="text-slate-700 text-sm mt-2">{cert.description}</div>
                </div>
            ))}
        </div>
    </section>
);

export default Certifications